import { useWatch } from 'react-hook-form'

import { isObservabilityToolOfType } from 'components/status-checks/authentication-form-validation-utils'
import { isDynatraceSelectorProblemsUrlType } from 'components/status-checks/status-checks-dynatrace-form-utils'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

const fieldsToWatch = ['dynatraceSelector', 'observabilityTool'] as const

/**
 * A convenience hook to determine whether the current Status Check meets the criteria to be categorized
 * as a Dynatrace Enhanced Status Check.
 */
export function useIsDynatraceEnhancedStatusCheck() {
  const [dynatraceSelector, observabilityTool] = useWatch<
    StatusCheckFormValues,
    typeof fieldsToWatch
  >({ name: fieldsToWatch })

  const isDynatraceObservabilityTool = isObservabilityToolOfType(
    ObservabilityToolType.DYNATRACE,
    observabilityTool
  )

  return (
    isDynatraceObservabilityTool &&
    !isDynatraceSelectorProblemsUrlType(dynatraceSelector)
  )
}
